import { cn } from '@/lib/utils';

export type FleetVehicleTabId =
  | 'stamm'
  | 'fahrer'
  | 'fristen'
  | 'kilometer'
  | 'schaeden'
  | 'werkstatt'
  | 'dokumente'
  | 'fahrten'
  | 'kosten';

const TAB_LABELS: Record<FleetVehicleTabId, string> = {
  stamm: 'Stamm',
  fahrer: 'Fahrer',
  fristen: 'Fristen',
  kilometer: 'Kilometer',
  schaeden: 'Schäden',
  werkstatt: 'Werkstatt',
  dokumente: 'Dokumente',
  fahrten: 'Fahrten',
  kosten: 'Kosten',
};

export function FleetVehicleTabNav({
  tab,
  onTab,
  showDeadlines,
  showMileage,
  showDamage,
  showWorkshop,
  showTrips,
  showCosts,
}: {
  tab: FleetVehicleTabId;
  onTab: (next: FleetVehicleTabId) => void;
  showDeadlines: boolean;
  showMileage: boolean;
  showDamage: boolean;
  showWorkshop: boolean;
  showTrips: boolean;
  showCosts: boolean;
}) {
  const tabs: FleetVehicleTabId[] = [
    'stamm',
    'fahrer',
    ...(showDeadlines ? (['fristen'] as const) : []),
    ...(showMileage ? (['kilometer'] as const) : []),
    ...(showDamage ? (['schaeden'] as const) : []),
    ...(showWorkshop ? (['werkstatt'] as const) : []),
    'dokumente',
    ...(showTrips ? (['fahrten'] as const) : []),
    ...(showCosts ? (['kosten'] as const) : []),
  ];

  return (
    <div
      className="-mx-1 flex gap-1 overflow-x-auto border-b pb-px"
      role="tablist"
      aria-label="Fahrzeug"
    >
      {tabs.map((id) => (
        <button
          key={id}
          type="button"
          role="tab"
          aria-selected={tab === id}
          onClick={() => onTab(id)}
          className={cn(
            'inline-flex min-h-11 shrink-0 items-center border-b-2 px-3 text-sm font-medium',
            tab === id
              ? 'border-primary text-primary'
              : 'border-transparent text-muted-foreground hover:text-foreground',
          )}
        >
          {TAB_LABELS[id]}
        </button>
      ))}
    </div>
  );
}
